import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
});

// Attach bearer token if present (fallback for cross-origin cookie issues)
api.interceptors.request.use((config) => {
    const t = typeof window !== "undefined" ? localStorage.getItem("pck_token") : null;
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});
